import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { apiError } from "@/context/AuthContext";
import { uploadFile } from "@/lib/api";
import ImageField from "@/components/ImageField";
import { toast } from "sonner";
import { Skull, Loader2, ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    company_name: "", phone: "", password: "", address: "", area: "",
  });
  const [proof, setProof] = useState(null);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/register", { ...form, proof_image: proof });
      toast.success("Đăng ký thành công! Chờ tài khoản gốc duyệt.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-[#0a0a0a] border border-zinc-800 text-white rounded-sm px-4 py-3 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors placeholder:text-zinc-600";
  const labelCls = "block text-xs font-semibold uppercase tracking-[0.1em] text-zinc-400 mb-2";

  return (
    <div className="min-h-screen bg-background noise-bg py-10 px-4">
      <div className="max-w-2xl mx-auto animate-fade-up">
        <Link to="/login" className="inline-flex items-center gap-2 text-zinc-500 hover:text-white text-sm mb-6 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Quay lại đăng nhập
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <div className="w-12 h-12 bg-primary flex items-center justify-center shadow-[0_0_20px_rgba(230,0,0,0.4)]">
            <Skull className="w-7 h-7 text-white" />
          </div>
          <h1 className="font-display text-3xl font-black text-white tracking-tight">Đăng ký nhà xe</h1>
        </div>
        <p className="text-zinc-500 mb-8 text-sm">
          Tài khoản sẽ được kích hoạt sau khi tài khoản gốc duyệt.
        </p>

        <form onSubmit={submit} className="space-y-5 bg-card border border-zinc-800 rounded-sm p-6">
          <div>
            <label className={labelCls}>Tên nhà xe *</label>
            <input data-testid="reg-company" value={form.company_name} onChange={set("company_name")} className={inputCls} required />
          </div>
          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <label className={labelCls}>Số điện thoại *</label>
              <input data-testid="reg-phone" value={form.phone} onChange={set("phone")} className={inputCls} placeholder="09xxxxxxxx" required />
            </div>
            <div>
              <label className={labelCls}>Mật khẩu *</label>
              <input data-testid="reg-password" type="password" value={form.password} onChange={set("password")} className={inputCls} required />
            </div>
          </div>
          <div>
            <label className={labelCls}>Địa chỉ nhà xe *</label>
            <input data-testid="reg-address" value={form.address} onChange={set("address")} className={inputCls} required />
          </div>
          <div>
            <label className={labelCls}>Khu vực hoạt động *</label>
            <input data-testid="reg-area" value={form.area} onChange={set("area")} className={inputCls} placeholder="VD: TP. Hồ Chí Minh" required />
          </div>
          <ImageField
            label="Ảnh nhà xe / ảnh chứng minh làm dịch vụ cho thuê tự lái"
            value={proof}
            onChange={setProof}
            testid="reg-proof"
            publicMode
          />
          <button
            data-testid="reg-submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-primary hover:bg-[#ff1a1a] text-white font-bold uppercase tracking-wide rounded-sm px-6 py-3 transition-colors disabled:opacity-50"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Gửi đăng ký
          </button>
        </form>
        <Footer />
      </div>
    </div>
  );
}
